// Modules
import React from 'react';
import { Outlet } from 'react-router-dom';

// Components
import Header from './header/HeaderView';
import Navigation from './navigation/NavigationView';

// Styling
import './content/table.scss';
import './content/pagination.scss';
import './content/contentWrapper.scss';
import './content/headers.scss';

const Layout = (props) => {
    return (
        <div className="page-container">
            <Header />
            <Navigation />
            {props.children}
            <Outlet />
        </div>
    );
};

export default Layout;
